import { Avatar, Button, Loader, Pagination } from "@mantine/core";
import "./CourseReviewsCard.css";
import { ReviewCounter } from "../../ReviewCounter/ReviewCounter";
import { useEffect, useState } from "react";
import axios from "axios";

const paginatedTestimonial = (testimonials, _page, _pageSize) => {
  if (!testimonials) return
  //APPLY PAGINATION
  const startIndex = (_page - 1) * _pageSize;
  const endIndex = startIndex + _pageSize;

  return testimonials.slice(startIndex, endIndex);
};

const PAGE_SIZE = 3

const CourseReviewsCard = ({ reviews, specialtyId }) => {
  const stats = [
    {
      title: "Moderación",
      data: [
        {
          num: reviews?.stats?.moderation?.good,
          label: "Votos positivos",
        },
        {
          num: reviews?.stats?.moderation?.average,
          label: "Votos regulares",
        },
        {
          num: reviews?.stats?.moderation?.bad,
          label: "Votos negativos",
        }
      ]
    },
    {
      title: "Experiencia",
      data: [
        {
          num: reviews?.stats?.forVetExperience?.good,
          label: "Votos positivos",
        },
        {
          num: reviews?.stats?.forVetExperience?.average,
          label: "Votos regulares",
        },
        {
          num: reviews?.stats?.forVetExperience?.bad,
          label: "Votos negativos",
        }
      ]
    },
    {
      title: "Campus",
      data: [
        {
          num: reviews?.stats?.webCampusValue?.good,
          label: "Votos positivos",
        },
        {
          num: reviews?.stats?.webCampusValue?.average,
          label: "Votos regulares",
        },
        {
          num: reviews?.stats?.webCampusValue?.bad,
          label: "Votos negativos",
        }
      ]
    },
  ]

  const hasAnyValue = stats.some(section =>
    section.data.some(item => (item.num ?? 0) > 0)
  );

  const validatedStats = hasAnyValue ? stats : null;

  const data = reviews?.testimonies

  const [isRates, setIsRates] = useState(false)
  const [relatedReviews, setRelatedReviews] = useState([])
  const [isRelatedReviewsPending, setIsRelatedReviewsPending] = useState(false)

  const totalPages = Math.ceil(relatedReviews?.length / PAGE_SIZE) || 1
  const [page, setPage] = useState(1)

  useEffect(() => {

    if ((!data || data.length === 0) && specialtyId) {
      const getReviewRelated = async () => {
        setIsRelatedReviewsPending(true)
        const url = process.env.REACT_APP_BACKEND_SERVER + `/info/review-related/${specialtyId}`;

        try {
          const { data: _related_reviewed } = await axios.get(url)
          setRelatedReviews(_related_reviewed)
          setIsRelatedReviewsPending(false)

        } catch (error) {
          console.log(error)
          setIsRelatedReviewsPending(false)
        }
      }
      getReviewRelated()
    }
  }, [specialtyId, data])

  const no_content = data.length === 0 && relatedReviews.length === 0

  return (
    <div className="courseReviewsCard-container">
      <div className="courseReviewsCard--select-button-wrapper">
       {!no_content && <Button type="button" variant={isRates ? "outline" : "filled"} color="var(--color-primary-dark)" onClick={() => setIsRates(prev => !prev)}>
          Comentarios
        </Button>}
        {validatedStats && <Button type="button" variant={!isRates ? "outline" : "filled"} color="var(--color-primary-dark)" onClick={() => setIsRates(prev => !prev)}>
          Puntos
        </Button>}
      </div>
      {isRates && validatedStats && <div className="courseReviewsCard-grid-stat-container">
        {stats?.map(item => {
          return <ReviewCounter data={item.data} title={item.title} />
        })}
      </div>}

      {!isRates && <>
        {no_content && (
          <p className="courseReviewsCard-no-reviews">
            Aún no hay valoraciones
          </p>
        )}
        {data && data.length > 0 ? data.map((testimonies) => (
          <div className="courseReviewscard-card-content-container">
            <div className="courseReviewscard-content-container-div">
              <div className="courseReviewscard-avatar-and-text-container-div">
                <Avatar
                  src={testimonies.profilePicture}
                  alt={testimonies.name}
                  radius="xl"
                  size="lg"
                />
                <div className="courseReviewscard-personal-info-div-container">
                  <h5 className="courseReviewscard-personal-info-h5-title">
                    {testimonies.name}
                  </h5>
                  <p className="courseReviewscard-date-p">
                    {testimonies.date}
                  </p>
                </div>
              </div>

              <div className="courseReviewsCard-typography-p-custom">
                <p>{testimonies.review}</p>
              </div>
            </div>
          </div>
        ))
          : isRelatedReviewsPending ? <Loader /> :
            relatedReviews && relatedReviews?.length > 0 ? <div>
              <h3 className="courseReviewscard-relatedReviews-title">Sobre la especialidad a la cual corresponde esta unidad academica</h3>
              {paginatedTestimonial(relatedReviews, page, PAGE_SIZE).map(item => {
                const data = item.reviews
                const from = item.acaUnit
                return data.map(_review => (
                  <div key={_review.id} className="courseReviewscard-card-content-container">
                    <div className="courseReviewscard-content-container-div">
                      <div className="courseReviewscard-avatar-and-text-container-div">
                        <Avatar
                          src={_review.profilePicture}
                          alt={_review.name}
                          radius="xl"
                          size="lg"
                        />
                        <div className="courseReviewscard-personal-info-div-container">
                          <h5 className="courseReviewscard-personal-info-h5-title">
                            {_review.name}
                          </h5>
                          <h3>Realizó {from}</h3>
                        </div>
                      </div>

                      <div className="courseReviewsCard-typography-p-custom">
                        <p>{_review.review}</p>
                      </div>
                    </div>
                  </div>
                ))
              })}
              <div className="testimonialGrid-pagination">
                <Pagination value={page} onChange={setPage} total={totalPages} />
              </div>
            </div> : <></>
        }
      </>}
    </div>
  );
};
export default CourseReviewsCard;
